import { render } from "./CanvasIntroduction.vue?vue&type=template&id=1ecca124&scoped=true&ts=true"
import script from "./CanvasIntroduction.vue?vue&type=script&lang=ts"
export * from "./CanvasIntroduction.vue?vue&type=script&lang=ts"

import "./CanvasIntroduction.vue?vue&type=style&index=0&id=1ecca124&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecca124"]])

export default __exports__